var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesShortAnswer = function SvgShotEyesShortAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesShortAnswer_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesShortAnswer_svg__st1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3h15c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-15C3 3.7 3.7 3 4.5 3z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7h6M12 10.3h6M6 13.7h12M6 17h12",
    className: "shotEyesShortAnswer_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 7v3.5",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 0.7868,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h3.4",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 0.8333,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }));
};
export default SvgShotEyesShortAnswer;